module.exports = __webpack_public_path__ + "img/Matthew Hammett.14d2d102.jpg";